import { HttpParams } from '@angular/common/http';
import { ScanItem, ScanItemState } from '../scan/entities/scan-item.entity';
import { DIGIHAVEN_PROTOCOL, LOCATION_LEGACY_PROTOCOL } from './constants';

export const ParseScanItem: (scannedValue: string | undefined) => ScanItem = (
    scannedValue: string | undefined
): ScanItem => {
    const baseValue = scannedValue || '';
    const rawValue: string[] = baseValue
        .replace(DIGIHAVEN_PROTOCOL, '')
        .replace(LOCATION_LEGACY_PROTOCOL, '')
        .split('?');
    const recordId: string = rawValue[0] || '';
    const query: HttpParams = new HttpParams({ fromString: rawValue[1] || '' });

    return {
        id: recordId,
        state: ScanItemState.Loading,
        ...(query.has('index') ? { index: Number.parseInt(query.get('index')!) } : {})
    };
};
